<hawk-record-navigation
  class="app-page"
  [breadcrumbLinkList]="[{ description: 'Kunden', link: '/a/kunde' }]"
  [root]="'customer'"
  [leafDescription]="'Neuer Kunde'"
>
  <div class="page-content page-frame overflow-y-auto flex flex-col gap-4">
    <form [formGroup]="customerForm" class="page-sheet w-full max-w-5xl mx-auto grid grid-cols-2" (submit)="onSubmit()">
      <div class="bm-card bm-card-sm">
        <fieldset class="bm-card-body">
          <h2 class="bm-card-title">Stammdaten</h2>
          <label class="bm-fieldset-label">Abkürzung*</label>
          <input class="bm-input w-full" maxlength="3" matInput formControlName="letter" />
          <div>Artikel des Kunden erhalten eine RMA mit dieser Abkürzung. Verwenden Sie maximal drei Buchstaben.</div>

          <label class="bm-fieldset-label">Name*</label>
          <input class="bm-input w-full" formControlName="name" />

          <label class="bm-fieldset-label">URL</label>
          <input class="bm-input w-full" formControlName="url" />

          <label class="bm-fieldset-label">XML-ID</label>
          <input class="bm-input w-full" formControlName="xml_id" />
          <div>Für den XML-Export von Tickets</div>

          <label class="bm-fieldset-label">Info</label>
          <textarea class="bm-textarea w-full" formControlName="additional_information"></textarea>
        </fieldset>
      </div>
      <section class="bm-card bm-card-sm">
        <fieldset class="bm-card-body relative">
          <h2 class="bm-card-title">Adresse</h2>
          <div class="absolute top-0 right-0" id="address_geocoder"></div>
          <label class="bm-fieldset-label">Firma</label>
          <input class="bm-input w-full" formControlName="company" />

          <label class="bm-fieldset-label">Straße</label>
          <input class="bm-input w-full" formControlName="street" />

          <label class="bm-fieldset-label">PLZ / Ort</label>
          <div class="flex flex-row w-full">
            <input class="bm-input flex-1" formControlName="zip" placeholder="PLZ" />
            <input class="bm-input flex-2" formControlName="city" />
          </div>

          <label class="bm-fieldset-label">Land</label>
          <input class="bm-input w-full" formControlName="country" />

          <label class="bm-fieldset-label">Staat</label>
          <input class="bm-input w-full" formControlName="state" />
        </fieldset>
      </section>

      <div class="flex flex-row gap-2 col-span-2 justify-end">
        <a [routerLink]="'/kunde'" class="bm-btn"> Abbrechen </a>
        <button class="bm-btn bm-btn-primary" [disabled]="!customerForm.valid">Kunden erstellen</button>
      </div>
    </form>
  </div>
</hawk-record-navigation>
